import {Component, useState} from 'react';
import Layers from './layers';
import Viewport from '../utils/viewport';
import LoaderUtil from '../utils/loader';
import Background from './layers/background';
import {connect} from 'react-redux';
import Selector from '../selectors/layout';
import {bindActionCreators} from 'redux';
import {appPreloaded} from '../reducers/app/actions';
import {loadUser} from '../reducers/user/actions';
import {loadJackpots} from '../reducers/app/actions';
import {Routes, Route} from 'react-router-dom';
import Scenes from '../views/scenes';
import WSocket from '../utils/websocket';
import Modals from './modals';

class Layout extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="viewport">
                    {this.props.preloaded ? (
                        <>
                            <Background isAuth={this.props.user.isAuth} />
                            <Layers.Loader />
                            <Modals />

                            <Routes>
                                <Route path="/home" Component={Layers.Main} />
                                <Route path="/login" Component={Layers.Login} />
                            </Routes>
                        </>
                    ) : (
                        <Layers.PreLoader />
                    )}      
                </div>          
                <Layers.Rotate />
                {this.props.preloaded && <Scenes.Game />}
            </>
        )
    }

    componentDidMount() {
        if(!this.props.loaded && window.location.pathname !== '/')
            window.location.pathname = '/';

        window.addEventListener('resize', Viewport.resize);
        Viewport.resize();
        Viewport.isSafari();

        if(!this.props.preloaded)
            LoaderUtil.preloader({
                onComplete: () => this.props.appPreloaded(),
                onError: object => {
                    console.error(`${object.path} can't be loaded!`);
                }
            }).start();

        if(!this.props.user.loaded) this.props.loadUser();
        if(!this.props.jackpots_loaded) this.props.loadJackpots();

        WSocket.init();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', Viewport.resize);
    }
}

export default connect(Selector, dispatch => bindActionCreators({
    appPreloaded,
    loadUser,
    loadJackpots
}, dispatch)) (Layout);